// src/UIRegistry.js

/**
 * UIRegistry centralizes all DOM references for the application.
 * This avoids redundant getElementById calls and makes refactoring easier.
 */
export const UIRegistry = {
  getElements() {
    const rawElements = {
      // Navigation & Main Areas
      menuArea: document.getElementById('menu-area'),
      gameArea: document.getElementById('encounter-area'),
      
      // Main Buttons
      runGuardDirect: document.getElementById('runGuardDirect'),
      runGuard: document.getElementById('runGuard'),
      runLibrary: document.getElementById('runLibrary'),
      runSimulation: document.getElementById('runSimulation'),
      
      // HUD & Stats
      levelValue: document.getElementById('level-value'),
      credits: document.getElementById('credits'),
      xp: document.getElementById('xp'),
      stamina: document.getElementById('daily'),
      staminaTimer: document.getElementById('stamina-timer'),
      streak: document.getElementById('streak'),
      bestStreak: document.getElementById('best-streak'),
      levelBar: document.getElementById('level-bar'),
      levelText: document.getElementById('level-text'),
      
      // Encounter UI
      enunciado: document.getElementById('node-enunciado'),
      options: document.getElementById('options-grid'),
      progressBar: document.getElementById('progress-bar'),
      progressText: document.getElementById('progress-text'),
      learningNote: document.getElementById('learning-note'),
      caseMeta: document.getElementById('case-meta'),
      caseTags: document.getElementById('case-tags'),
      
      // Vitals Monitor
      vitalsFill: document.getElementById('vitals-fill'),
      vitalsTimer: document.getElementById('vitals-timer'),
      patientStability: document.getElementById('patient-stability'),
      stabilityBar: document.getElementById('stability-bar'),
      vitalTa: document.getElementById('vital-ta'),
      vitalFc: document.getElementById('vital-fc'),
      vitalSat: document.getElementById('vital-sat'),
      vitalMental: document.getElementById('vital-mental'),
      
      // RPG & Skills
      skillBtn: document.getElementById('btn-active-skill'),
      skillArea: document.getElementById('active-skill-area'),
      skillName: document.getElementById('skill-name'),
      skillDesc: document.getElementById('skill-desc'),
      questList: document.getElementById('quest-list'),
      spCount: document.getElementById('sp-count') || document.getElementById('modal-sp-count'),
      burnoutUI: document.getElementById('burnout-ui'),
      burnoutText: document.getElementById('burnout-text'),
      
      // Modals
      hubModal: document.getElementById('clinical-hub-modal'),
      specialtyModal: document.getElementById('specialty-selection-modal'),
      specialtyGrid: document.getElementById('specialty-grid'),
      closeSpecialtySelection: document.getElementById('close-specialty-selection'),
      caseModal: document.getElementById('case-selection-modal'),
      tabBtns: document.querySelectorAll('.tab-btn'),
      tabPanels: document.querySelectorAll('.hub-tab-panel'),
      btnRanking: document.getElementById('btn-ranking'),
      btnRounds: document.getElementById('btn-rounds'),

      
      rosterContainer: document.getElementById('roster-container'),
      achievementTray: document.getElementById('achievement-tray'),
      
      // Lists & Logs
      rosterList: document.getElementById('roster'),
      gachaLog: document.getElementById('gachaLog'),
      nightShiftList: document.getElementById('night-shift-list'),
      guardLog: document.getElementById('guardLog'),
      caseList: document.getElementById('case-list-container'),
      
      // Helpers & Buttons
      hudBtnHub: document.getElementById('hud-btn-hub'),
      menuBtnHub: document.getElementById('menu-btn-hub'),
      btnAtlas: document.getElementById('btn-atlas'),
      helpButton: document.getElementById('help-button'),
      closeHub: document.getElementById('close-hub'),
      closeRoster: document.getElementById('close-roster'),

      btnRoster: document.getElementById('btn-roster'),
      btnPerks: document.getElementById('btn-perks'),
      closePerks: document.getElementById('close-perks'),
      closeCaseSelection: document.getElementById('close-case-selection'),
      hintArea: document.getElementById('hint-area'),
      hintText: document.getElementById('hint-text'),
      hintButton: document.getElementById('hint-button'),
      pull1: document.getElementById('pull1'),
      pull10: document.getElementById('pull10'),
      
      // Quests/Goals
      modalSpCount: document.getElementById('modal-sp-count'),

      // RPG / Perks
      perkTreeContainer: document.getElementById('perk-tree-container'),

      // Feedback & Recovery
      feedbackOverlay: document.getElementById('feedback-overlay'),
      feedbackBody: document.getElementById('feedback-body'),
      nextBtn: document.getElementById('next-btn'),
      exitLethal: document.getElementById('exit-lethal'),

      // Atlas & Progression
      atlasList: document.getElementById('atlas-list'),
      licensesCount: document.getElementById('licenses-count'),
      badgesCount: document.getElementById('badges-count'),
      patientMonitor: document.getElementById('patient-monitor'),
      objectiveHinter: document.getElementById('objective-hinter'),
      rankingList: document.getElementById('ranking-list'),
    };

    const warned = new Set();
    // Safe Proxy to prevent "cannot read property style of null" errors
    return new Proxy(rawElements, {
      get(target, prop) {
        if (target[prop]) return target[prop];
        
        if (!warned.has(prop)) {
            console.warn(`[UIRegistry] Elemento DOM faltante solicitado: #${String(prop)}`);
            warned.add(prop);
        }
        
        // Return a mock element for missing IDs to keep the engine running silently
        return {
          style: {},
          classList: { add: () => {}, remove: () => {}, contains: () => false, toggle: () => {} },
          appendChild: () => {},
          innerHTML: '',
          textContent: '',
          innerText: '',
          onclick: null,
          addEventListener: () => {},
          removeEventListener: () => {},
          querySelector: () => null,
          querySelectorAll: () => [],
          getAttribute: () => null,
          setAttribute: () => {},
          removeAttribute: () => {},
          dataset: {},
          parentElement: null,
          remove: () => {}
        };
      }
    });
  }
};
